export function addToConsole(context) {
    window.__CONTEXT = context;
    window.__SERVICE = context.services.reduce(function (acc, service) {
        acc[service.serviceName || service.constructor.name] = service;
        return acc;
    }, {});
}
